module.exports = __webpack_public_path__ + "img/05-oval-not-convex-3.abb215a7.svg";